import axios from 'axios'
import {API_URL} from '../../../../_metronic/helpers'
import {StartedPayment} from '../../online-payment/core/onlinePaymentApi'

// «دسته‌بندی شناسه کالا/خدمت» (backend 1.0.0.675+, user request 2026-10-18): browsing the IDs by group or subgroup is a
// value-added service once an administrator prices it; plain search stays free.

/** The search's refusal of a category it is not open to (403). */
export const CATEGORIES_LOCKED = 'STUFFID_CATEGORIES_LOCKED'

export type CategoryLockState = 'signIn' | 'locked'

/** One period a person may buy the categories for, VAT included; months null is for ever. */
export type CategoryOffer = {
  months?: number | null
  title: string
  amount: number
  listAmount?: number | null
  vatRate: number
  vat: number
  payable: number
}

export type CategoryAccess = {
  open: boolean
  state: 'open' | CategoryLockState
  /** free, server, administrator, business or subscription. */
  openBy?: string | null
  priced: boolean
  reason?: string | null
  signedIn: boolean
  subscription?: {endsAt?: string | null; endsAtLabel?: string | null} | null
  /** The business the signed-in user works in: the service is turned on for it in the panel. */
  business?: {companyId: number; active: boolean; servicesPath: string; description?: string | null} | null
  offers: CategoryOffer[]
}

/** The refusal of a search by category, if that is what the error is. */
export const readCategoryLock = (error: unknown): {state: CategoryLockState; message: string} | undefined => {
  const data = (error as {response?: {status?: number; data?: {code?: string; state?: string; message?: string}}})?.response
  if (data?.status !== 403 || data.data?.code !== CATEGORIES_LOCKED) return undefined
  return {
    state: data.data.state === 'signIn' ? 'signIn' : 'locked',
    message: data.data.message || 'مرور شناسه‌ها به تفکیک دسته‌بندی سرویس ویژه است.',
  }
}

export const getCategoryAccess = async (): Promise<CategoryAccess> =>
  (await axios.get<CategoryAccess>(`${API_URL}/stuffid/categories/access`)).data

/** The person's own subscription: answers where the browser goes (the organisation's gateway). */
export const startCategorySubscription = async (months: number | null | undefined, returnPath: string): Promise<StartedPayment> =>
  (await axios.post<StartedPayment>(`${API_URL}/stuffid/categories/subscription`, {months: months ?? null, returnPath})).data
